<template>
    <div class="new-password-form">
        <h2>Criar senha</h2>

        <div>
            <b-form @submit.stop.prevent="onSubmit" novalidate>
                <b-form-group label="Nova senha" label-for="password" class="password-field">
                    <b-input-group>
                        <b-form-input
                            id="password"
                            v-model="$v.form.password.$model"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder="Digite uma nova senha"
                            :state="validateState('password')"
                        >
                        </b-form-input>
                        <b-input-group-append class="btn-eye-password">
                            <b-button class="btn" @click="showPassword = !showPassword">
                                <i :class="`fas fa-${showPassword ? 'eye' : 'eye-slash'}`"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>

                    <b-form-invalid-feedback :state="validateState('password')">
                        <div v-if="!$v.form.password.required">
                            Campo obrigatório
                        </div>

                        <div v-if="!$v.form.password.minLength">
                            Deve conter no mínimo 8 caracteres
                        </div>

                        <div v-if="!$v.form.password.containsUppercase">
                            Deve conter no mínimo 1 letra maiúscula
                        </div>

                        <div v-if="!$v.form.password.containsNumber">
                            Deve conter no mínimo 1 número
                        </div>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Confirmar senha" label-for="confirmPassword" class="password-field">
                    <b-input-group>
                        <b-form-input
                            id="confirm-password"
                            v-model="$v.form.confirmPassword.$model"
                            :type="showConfirmPassword ? 'text' : 'password'"
                            placeholder="Digite novamente sua senha"
                            :state="validateState('confirmPassword')"
                        >
                        </b-form-input>
                        <b-input-group-append class="btn-eye-password">
                            <b-button class="btn" @click="showConfirmPassword = !showConfirmPassword">
                                <i :class="`fas fa-${showConfirmPassword ? 'eye' : 'eye-slash'}`"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>

                    <b-form-invalid-feedback :state="validateState('confirmPassword')">
                        <div v-if="!$v.form.confirmPassword.required">
                            Campo obrigatório
                        </div>
                        <div v-if="!$v.form.confirmPassword.sameAsPassword && form.confirmPassword">
                            Senhas devem ser iguais
                        </div>
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-button type="submit" :variant="getIsDarkTheme ? 'primary' : 'dark'" class="radius-6 submit"
                    >Criar senha</b-button
                >
            </b-form>
        </div>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <DangerMsgModal :msg="message" v-if="sendToLogin" />
                <SuccessMsgModal :msg="message" v-else />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="$router.push({ name: 'LoginForm' })" v-if="sendToLogin">
                    Entendi
                </b-button>

                <b-button variant="primary" @click="$router.push({ name: 'LoginForm' })" v-else>
                    Acessar Plataforma
                </b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import DangerMsgModal from '@/ui/modal/danger-msg-modal/DangerMsgModal'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AuthenticationApi } from '../../api/authentication'

const authenticationApi = new AuthenticationApi()

export default {
    components: { SuccessMsgModal, DangerModalPP, DangerMsgModal },
    data() {
        return {
            message: null,
            showPassword: false,
            showConfirmPassword: false,
            sendToLogin: false,
            form: {
                password: null,
                confirmPassword: null
            }
        }
    },
    validations: {
        form: {
            password: {
                required,
                minLength: minLength(8),
                containsUppercase: function(value) {
                    return /[A-Z]/.test(value)
                },
                containsNumber: function(value) {
                    return /[0-9]/.test(value)
                }
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs('password')
            }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getAccessTemp() {
            return this.$store.state.accessTemp
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setAccessTemp']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            if (this.getAccessTemp) {
                const data = {
                    email: this.getAccessTemp.user.email,
                    code: this.getAccessTemp.code,
                    password: this.form.password
                }

                this.setIsLoading(true)

                authenticationApi
                    .createNewPassword(data)
                    .then(response => {
                        this.message = response.data.message
                        this.setAccessTemp(null)
                        this.showModal('warning-modal-ref')
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            } else {
                this.message = 'Você não possui autorização!\nAcesse o link direcionando ao seu e-mail.'
                this.sendToLogin = true
                this.showModal('warning-modal-ref')
            }
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        }
    },
    mounted() {
        this.currentRouterName = this.$router.history.current.name
        const routeParams = this.$router.history.current.params
        const paramsKeys = Object.keys(routeParams)

        if (paramsKeys.length) {
            if (this.currentRouterName === 'NewPasswordByEmail') {
                this.setIsLoading(true)
                const data = { email: routeParams.email, code: routeParams.code }

                authenticationApi
                    .confirmPwdByEmail(data)
                    .then(response => {
                        this.setAccessTemp(response.data.data)
                        this.$router.push({ name: 'NewPasswordForm' })
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.sendToLogin = true
                        this.showModal('warning-modal-ref')
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        }
    }
}
</script>

<style scope src="./NewPasswordForm-light-theme.css"></style>
<style scope src="./NewPasswordForm-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/components/new-password-form/NewPasswordForm.vue